import ResetPassword from '@/store/modules/resetPassword/constants';
import AccountService from '@/services/accountService';

const accountService = new AccountService();

export default {
  [ResetPassword.actionTypes.sendResetPasswordRequest]({ commit }, email) {
    commit(ResetPassword.mutationTypes.setResetPasswordRequestLoading, true);

    return accountService.sendResetPasswordRequest(email)
      .then((requestResult) => {
        commit(ResetPassword.mutationTypes.setResetPasswordRequestLoading, false);

        return Promise.resolve(requestResult);
      })
      .catch((errorType) => {
        commit(ResetPassword.mutationTypes.setResetPasswordRequestLoading, false);

        return Promise.reject(errorType);
      });
  },

  [ResetPassword.actionTypes.validateResetPasswordToken]({ commit }, resetPasswordToken) {
    commit(ResetPassword.mutationTypes.setResetTokenValidating, true);

    return accountService.validateResetPasswordToken(resetPasswordToken)
      .then((validationResult) => {
        commit(ResetPassword.mutationTypes.setResetTokenValidating, false);
        return Promise.resolve(validationResult);
      })
      .catch(() => {
        commit(ResetPassword.mutationTypes.setResetTokenValidating, false);
      });
  },

  [ResetPassword.actionTypes.resetPassword]({ commit }, resetPasswordInfo) {
    commit(ResetPassword.mutationTypes.setResetPasswordLoading, true);

    return accountService.resetPassword(resetPasswordInfo)
      .then(() => {
        commit(ResetPassword.mutationTypes.setResetPasswordLoading, false);

        return Promise.resolve(true);
      })
      .catch(() => {
        commit(ResetPassword.mutationTypes.setResetPasswordLoading, false);

        return Promise.resolve(false);
      });
  },
};
